import { CarePlanCondition } from "src/_mock/settings/_careplan-automation";
import client from "../../_client";

export async function findCarePlanConditions() {
  const { data } = await client.get<CarePlanCondition[]>(`/care-plan/conditions`);
  return data;
}